<template>
  <div class="footer-customer" :style="{ 'background-image': 'url(' + image + ')' }">
    <div class="customer-footer-mobilediv" v-if="window.innerWidth < 600">
      <img v-if="index != 0" @click="showAppDetailsNew(index - 1)" src="/static/img/back@3x.png" class="footer-back-customer">
      <img v-if="index < size-1" @click="showAppDetailsNew(index + 1)" src="/static/img/back-copy@3x.png" class="footer-forward-customer">
    </div>
    <div class="customer-footer-textdiv">
      <div v-if="index != 0" @click="showAppDetailsNew(index - 1)" class="customer-footer-text">Previous</div>
      <img src="/static/img/costumers/GreenIq/hippo-back-01.png" class="footer-customer-image">
      <div v-if="index < size-1" @click="showAppDetailsNew(index + 1)" class="customer-footer-text"> Next</div>
    </div>
  </div>
</template>
<script>

  export default {
    name: 'CustomerFooter',
    data() {
      return {
        image: this.projectFooterData.footerbackgroundimage,
        window
      }
    },
    props: {
      projectFooterData: {
        footerbackgroundimage: String,
        footermobilebackgroundimage: String
      },
      index: {
        type: Number
      },
      size: {
        type: Number
      }
    },
    methods: {
      showAppDetailsNew: function(projectIndex) {
        if (projectIndex < this.size && projectIndex >= 0)
        {
          this.$router.push({ name: 'CustomerMain', params: { id: String(projectIndex) }})
          this.$router.go(0);
        }
      }
    },
    created() {
      this.image = window.innerWidth > 600 ? this.projectFooterData.footerbackgroundimage : this.projectFooterData.footermobilebackgroundimage
    }
  }
</script>
<style>
  @import "../../assets/scss/customerFooter.scss";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerFooter.vue